export default __webpack_public_path__ + "media/images/footer-x-social-46d5174991fc045f1f1abdf3aa3178c6.svg";